<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
import DefaultFull from '../../default/groups/Full.vue'

const props = defineProps({
  item: Array,
})
</script>

<template>
  <DefaultFull v-bind="props" />
</template>
